import {useState} from "react";

import {ViolationService} from "violation/service";
import {violation_view_adapter} from "violation/model";
import {holder_view_adapter} from "holder/model";
import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider";

import {SectionCard, SectionCardHeaderAction} from "base/ui/section/components";
import {ViolationForm} from "violation/presentational/form";
import {HolderBasicDataSection} from "holder/presentational";
import {
    HolderForm,
    HolderInitialDataFormFields,
    HolderFormSearch,
} from "holder/presentational/form";
import {FormContainer} from "base/form/components";
import {NoDataContainer} from "base/shared/components";
import {EntityAddButtonGroup} from "base/entity/components/presentational";
import EditIcon from "@mui/icons-material/Edit";

const ViewOrUpdateViolationHolderContent = ({violation, allowEdit = true}) => {
    const {handleErrors} = useErrors();

    const navigate = useNavigateWithReload();
    const holder = violation.holder;

    const [selectedHolder, setSelectedHolder] = useState(null);
    const [mode, setMode] = useState("view");

    const handleSelectHolder = holder => {
        setSelectedHolder(holder);
    };

    const handleCreateFormSubmit = holder => {
        ViolationService.createHolder(violation.id, holder_view_adapter({...holder}))
            .then(createdHolder => {
                setMode("view");
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    const handleEditFormSubmit = () => {
        ViolationService.update(
            violation_view_adapter({...violation, holder: selectedHolder})
        )
            .then(updatedViolation => {
                setMode("view");
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    const secondaryActions = holder?.id
        ? [
              <SectionCardHeaderAction
                  key="edit"
                  name="edit"
                  text="Modificar"
                  icon={<EditIcon />}
                  onClick={() => {
                      setMode("search");
                  }}
              />,
          ]
        : null;

    const getComponent = mode => {
        if (mode === "view") {
            return holder ? (
                <HolderBasicDataSection holder={holder} />
            ) : (
                <NoDataContainer
                    text="Esta infracção ainda não tem um infractor/a associado."
                    button={
                        allowEdit && (
                            <EntityAddButtonGroup
                                onAdd={() => setMode("new")}
                                onSearch={() => setMode("search")}
                            />
                        )
                    }
                />
            );
        }
        if (mode === "new") {
            return (
                <HolderForm
                    onSubmit={handleCreateFormSubmit}
                    onCancel={() => {
                        setMode("view");
                    }}
                >
                    <FormContainer>
                        <HolderInitialDataFormFields />
                    </FormContainer>
                </HolderForm>
            );
        }
        if (mode === "search") {
            return (
                <FormContainer>
                    <ViolationForm
                        violation={violation}
                        onSubmit={handleEditFormSubmit}
                        onCancel={() => {
                            setMode("view");
                        }}
                    >
                        <HolderFormSearch onClickSelected={handleSelectHolder} />
                    </ViolationForm>
                </FormContainer>
            );
        }
    };

    return (
        <SectionCard
            title="Infractor/a"
            secondaryActions={allowEdit ? secondaryActions : null}
        >
            {getComponent(mode)}
        </SectionCard>
    );
};

export default ViewOrUpdateViolationHolderContent;
